import { render, staticRenderFns } from "./purchase-type-tab.vue?vue&type=template&id=47c78c38"
import script from "./purchase-type-tab.vue?vue&type=script&lang=js"
export * from "./purchase-type-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports